import { Component, OnInit } from '@angular/core';
import { HomeDashboardService } from '../../data/services/view/home-dashboard.service';

@Component({
  selector: 'app-clients-overdue',
  templateUrl: './clients-overdue.component.html',
  styleUrls: ['./clients-overdue.component.scss']
})
export class ClientsOverdueComponent implements OnInit {
  clientsOverdue: any;
  chartData: any;
  chartOptions: any;

  constructor(private readonly dashboardService: HomeDashboardService) { }

  ngOnInit(): void {
    this.dashboardService.clientsOverdue().subscribe(data => {
      this.clientsOverdue = data;
      this.initChart();
    });
  }

  initChart() {
    if (!this.clientsOverdue?.data) return;

    const documentStyle = getComputedStyle(document.documentElement);
    const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
    const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

    const allMonths = new Set<string>();
    this.clientsOverdue.data.forEach((client: { overdueBalanceByMonth: {}; }) => {
      Object.keys(client.overdueBalanceByMonth).forEach(month => allMonths.add(month));
    });

    const sortedMonths = Array.from(allMonths).sort();
    const clientNames = this.clientsOverdue.data.map((client: { client: { name: string } }) => client.client.name);

    const datasets = sortedMonths.map((month, index) => {
      return {
        type: 'bar',
        label: month,
        backgroundColor: this.getColor(index),
        data: this.clientsOverdue.data.map((client: { overdueBalanceByMonth: { [key: string]: number } }) =>
          client.overdueBalanceByMonth[month] || 0
        )
      };
    });

    this.chartData = {
      labels: clientNames,
      datasets
    };

    this.chartOptions = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        tooltip: {
          mode: 'index',
          intersect: true
        },
        legend: {
          labels: false
        },
      },
      scales: {
        x: {
          stacked: true, // Barras apiladas por meses
          ticks: { color: textColorSecondary },
          grid: { color: surfaceBorder, drawBorder: false }
        },
        y: {
          stacked: true, // Valores acumulativos por mes
          ticks: { color: textColorSecondary },
          grid: { color: surfaceBorder, drawBorder: false }
        }
      }
    };
  }

  getColor(index: number): string {
    const colors = [
      '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
      '#FF9F40', '#C9CBCF', '#8D6E63', '#26A69A', '#EF5350'
    ];
    return colors[index % colors.length];
  }
}
